import TooltipEx from "@components/Tooltip";
import React from "react";
import classNames from "classnames";
import styles from "src/pages/presenze/monitorWF/filtroRichiesteWF.module.css"
import {UseFormGetValues, UseFormSetValue} from "react-hook-form";
import {MonitorWfForm} from "./monitorWF";
import {IconAsterisk, IconCircleCheckFilled, IconTrash} from "@tabler/icons-react";

interface FiltroValiditaProps {
    setValue: UseFormSetValue<MonitorWfForm>,
    getValues: UseFormGetValues<MonitorWfForm>,
    statiClassName: string,
}

export const FiltroValidita: React.FC<FiltroValiditaProps> = ({setValue, getValues, statiClassName}) => {

    let selectAll = getValues('validita.selectAll');
    let valida = getValues('validita.VALIDA');
    let annullata = getValues('validita.ANNULLATA');

    return <div className="inline-flex items-center px-2">Validit&agrave;:&nbsp;
        <div className={`${styles.statiFilter} ${statiClassName}`}>
            <a key="selectAll" className={classNames(styles.stateContainer, styles.hoverClass, selectAll ? styles.selectedClass : '')}
               onClick={() => {
                   setValue('validita.selectAll', true)
                   setValue('validita.VALIDA', false)
                   setValue('validita.ANNULLATA', false)
               }}>
                <IconAsterisk size={14}/>
            </a>
            <TooltipEx tooltip={`Valide`}>
                <button key="VALIDA" type="button"
                        className={classNames(styles.stateContainer, styles.hoverClass, valida ? styles.selectedClass : '')}
                        onClick={() => {
                            setValue('validita.selectAll', false)
                            setValue('validita.VALIDA', true)
                            setValue('validita.ANNULLATA', false)
                        }}>
                    <IconCircleCheckFilled size={17}/>
                </button>
            </TooltipEx>
            <TooltipEx tooltip={`Annullate`}>
                <button key="ANNULLATA" type="button"
                        className={classNames(styles.stateContainer, styles.hoverClass, annullata ? styles.selectedClass : '')}
                        onClick={() => {
                            setValue('validita.selectAll', false)
                            setValue('validita.VALIDA', false)
                            setValue('validita.ANNULLATA', true)
                        }}>
                    <IconTrash className="h-4 w-4 text-red-600"/>
                </button>
            </TooltipEx>
        </div>
    </div>
};
